module.exports = __webpack_public_path__ + "static/media/codScreenshot.37c693fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/codScreenshot.png
// module id = 89
// module chunks = 0